/**
 * Opérateurs pour le filtrage des values des champs, hors checkbox
 * i = insensitive case
 * exact = égal
 * contains = like '%value%'
 * startswith = like '%value' : ne fonctionne pas avec un champ JSON
 * endswith = like 'value%' : ne fonctionne pas avec un champ JSON
 */
export enum FilterFieldOperator {
  EXACT = 'exact',
  IEXACT = 'iexact',
  CONTAINS = 'contains',
  ICONTAINS = 'icontains',
  /*STARTSWITH = 'startswith',
  ISTARTSWITH = 'istartswith',
  ENDSWITH = 'endswith',
  IENDSWITH = 'iendswith',*/
}
